import { Container, Drawer } from "@mui/material";
import React from "react";
import { DrawerContent } from "./content";
import { DrawerHeader } from "./header";

import "./styles.scss";
import { LanguageSelectionProps } from "./types";

const classNameBase = "scd-language-selection";
export const LanguageSelection = (
  props: LanguageSelectionProps,
): React.ReactElement => {
  return (
    <>
      <Drawer
        classes={{
          paper: `${classNameBase}-paper`,
        }}
        anchor="top"
        open={props.open}
        onClose={props.onClose}
        className={`${classNameBase}-container`}
        slotProps={{
          backdrop: { classes: { root: `scd-backdrop` } },
        }}
      >
        <Container maxWidth={"xl"}>
          <DrawerHeader onClose={props.onClose} />
          <DrawerContent onSelect={props.onClose} />
        </Container>
      </Drawer>
    </>
  );
};
